import { useMutation } from "@apollo/client";

import { CREATE_AGENT_SESSION_ID } from "_graphql/visal/mutations/createAgentSessionId";
import {
    CreateAgentSessionId,
    CreateAgentSessionIdVariables,
} from "../../_graphql/visal/mutations/__generated__/CreateAgentSessionId";

const useCreateSession = (variables: CreateAgentSessionIdVariables) => {
    const [mutateAsync, { data, loading }] = useMutation<
        CreateAgentSessionId,
        CreateAgentSessionIdVariables
    >(CREATE_AGENT_SESSION_ID, { variables });
    return {
        createSession: mutateAsync,
        session: data?.createAgentSessionId.session,
        isLoading: loading,
    };
};

export default useCreateSession;
